export default function countPostView(container = document) {
    const postId = container.dataset.postId;

    if (!postId || !window.gtPostViews) {
        return;
    }

    const formData = new FormData();

    formData.append('action', 'gt_count_post_view');
    formData.append('post_id', postId);
    formData.append('nonce', window.gtPostViews.nonce);

    fetch(window.gtPostViews.ajaxUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(data => {
            if (!data.success || !data.data.viewed) {
                return;
            }

            console.log('Просмотр засчитан:', data.data.views);

            // Обновляем все счётчики на странице
            document
                .querySelectorAll('[data-post-views]')
                .forEach(element => {
                    element.textContent = data.data.views;
                });
        })
        .catch(error => {
            console.error('Ошибка подсчёта просмотров:', error);
        });
}